import { Dialog } from '@mui/material';

import Button from '@/components/BaseLibrary/Button/Button';
import { IconName } from '@/components/Icon/Icon';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import type { FrontifyImageContent } from '@/contentful/contentful-exports';

import useStyles from './HighlightLightboxPlayer.styles';

interface HighlightLightboxImagePlayerProps {
  image: FrontifyImageContent;
  altText: string;
  isOpen: boolean;
  onClose: () => void;
}

const HighlightLightboxImagePlayer = ({
  image,
  altText,
  isOpen,
  onClose,
}: HighlightLightboxImagePlayerProps) => {
  const { classes } = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      role='dialog'
      className={classes.dialog}
      PaperProps={{ className: classes.paper }}
    >
      <Button
        iconName={IconName.CLOSE}
        onClick={onClose}
        aria-label='Close image'
        className={classes.closeButton}
      />
      <section
        data-testid='highlight-lightbox-player'
        className={classes.container}
      >
        <ResponsiveImage
          src={image}
          alt={altText}
          className={classes.image}
          sizes={{ xs: 640, sm: 1024, md: 1440, lg: 1920 }}
          priority
        />
      </section>
    </Dialog>
  );
};

export default HighlightLightboxImagePlayer;
